import React, { useEffect, useRef, useState } from 'react';
import socket from '../socket'; // Assuming socket is defined in src/socket.js
import { useNavigate } from "react-router-dom";

function RosaWApp() {
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const pcRef = useRef(null);
  const localStreamRef = useRef(null);
  const screenTrackRef = useRef(null);

  const [room, setRoom] = useState("");
  const [user] = useState("user-" + Math.floor(Math.random() * 10000));
  const [initiator, setInitiator] = useState(false);
  const [joined, setJoined] = useState(false);
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [videoEnabled, setVideoEnabled] = useState(true);
  const [screenSharing, setScreenSharing] = useState(false);
 const userEmail = sessionStorage.getItem('userEmail');
  const navigate = useNavigate();

  useEffect(() => {
    if (!userEmail) {
      navigate('/signin');
    }
  }, [userEmail, navigate]);



  const cleanupPeer = () => {
    if (pcRef.current) pcRef.current.close();
    pcRef.current = null;

    if (localStreamRef.current) {
      localStreamRef.current.getTracks().forEach(track => track.stop());
    }

    localStreamRef.current = null;
    screenTrackRef.current = null;

    setInitiator(false);
    setJoined(false);
    setAudioEnabled(true);
    setVideoEnabled(true);
    setScreenSharing(false);
  };

  const setupDataChannel = (channel) => {
    channel.onopen = () => {
      console.log("DataChannel opened");
    };

    channel.onmessage = (event) => {
      console.log("Received via DataChannel:", event.data);
    };

    channel.onerror = (e) => console.error("DataChannel error:", e);
    channel.onclose = () => {
      console.log("DataChannel closed");
    };

    pcRef.current.dataChannel = channel;
  };

  const startCall = async () => {
    if (!pcRef.current) return;
    try {
      const dataChannel = pcRef.current.createDataChannel("relayChannel");
      setupDataChannel(dataChannel);

      const offer = await pcRef.current.createOffer();
      await pcRef.current.setLocalDescription(offer);

      socket.emit("signal", { type: "offer", offer, room, user });
    } catch (err) {
      console.error("Offer error", err);
    }
  };

  const handleJoin = () => {
    if (room.trim()) {
      cleanupPeer();
      socket.emit("join", { room, user });
      setJoined(true);
    }
  };

  const handleEndCall = () => {
    cleanupPeer();
  };

  const handleToggleAudio = () => {
    const audioTrack = localStreamRef.current?.getAudioTracks()?.[0];
    if (audioTrack) {
      audioTrack.enabled = !audioTrack.enabled;
      setAudioEnabled(audioTrack.enabled);
    }
  };

  const handleToggleVideo = () => {
    const videoTrack = localStreamRef.current?.getVideoTracks()?.[0];
    if (videoTrack) {
      videoTrack.enabled = !videoTrack.enabled;
      setVideoEnabled(videoTrack.enabled);
    }
  };

  const handleShareScreen = async () => {
    if (!pcRef.current || !localStreamRef.current) return;

    if (!screenSharing) {
      try {
        const screenStream = await navigator.mediaDevices.getDisplayMedia({ video: true });
        const screenTrack = screenStream.getVideoTracks()[0];
        screenTrackRef.current = screenTrack;

        const sender = pcRef.current.getSenders().find(s => s.track.kind === "video");
        if (sender) sender.replaceTrack(screenTrack);

        screenTrack.onended = () => {
          handleStopShare();
        };

        setScreenSharing(true);
      } catch (err) {
        console.error("Screen share error:", err);
      }
    } else {
      handleStopShare();
    }
  };

  const handleStopShare = () => {
    const videoTrack = localStreamRef.current.getVideoTracks()[0];
    const sender = pcRef.current.getSenders().find(s => s.track.kind === "video");
    if (sender && videoTrack) sender.replaceTrack(videoTrack);
    screenTrackRef.current?.stop();
    setScreenSharing(false);
  };

  useEffect(() => {
    if (!joined) return;

    const pc = new RTCPeerConnection({
      iceServers: [
        {
          urls: 'turn:www.hydaxdroid.com:3478',
          username: 'user1',
          credential: 'pass123'
        }
      ]
    });

    pcRef.current = pc;

    navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then(stream => {
      localStreamRef.current = stream;
      if (localVideoRef.current) localVideoRef.current.srcObject = stream;
      stream.getTracks().forEach(track => pc.addTrack(track, stream));
    });

    pc.ontrack = event => {
      const [stream] = event.streams;
      if (remoteVideoRef.current) remoteVideoRef.current.srcObject = stream;
    };

    pc.onicecandidate = event => {
      if (event.candidate) {
        socket.emit("signal", { type: "ice", candidate: event.candidate, room, user });
      }
    };

    pc.ondatachannel = event => setupDataChannel(event.channel);

    socket.on("signal", async data => {
      if (!pcRef.current) return;
      if (data.type === "offer") {
        await pcRef.current.setRemoteDescription(new RTCSessionDescription(data.offer));
        const answer = await pcRef.current.createAnswer();
        await pcRef.current.setLocalDescription(answer);
        socket.emit("signal", { type: "answer", answer, room, user });
      } else if (data.type === "answer") {
        await pcRef.current.setRemoteDescription(new RTCSessionDescription(data.answer));
      } else if (data.type === "ice") {
        await pcRef.current.addIceCandidate(new RTCIceCandidate(data.candidate));
      }
    });

    socket.on("initiator", data => {
      if (data.initiatorUser === user) setInitiator(true);
    });

    return () => {
      cleanupPeer();
      socket.off("signal");
      socket.off("initiator");
    };
  }, [joined]);

  useEffect(() => {
    if (joined && initiator) {
      setTimeout(() => startCall(), 1500);
    }
  }, [initiator]);

  return (
    <div style={{ padding: 20, backgroundColor: "#e3f2fd", minHeight: "100vh" }}>
      <h2 style={{ color: "#1976d2", textAlign: "center" }}>ROSA W - WebRTC Video</h2>
      <div style={{ textAlign: 'center' }}>
        <p>Signed in as: {userEmail}</p>
      </div>

      <p><b>User:</b> {user}</p>

      {!joined ? (
        <>
          <input placeholder="Enter room" value={room} onChange={e => setRoom(e.target.value)} />
          <button onClick={handleJoin} style={{ backgroundColor: "#1565c0", color: "white", marginLeft: 10 }}>Join Room</button>
        </>
      ) : (
        <>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: 20 }}>
            <video ref={localVideoRef} autoPlay muted playsInline style={{ width: 320, border: '2px solid green' }} />
            <video ref={remoteVideoRef} autoPlay playsInline style={{ width: 320, border: '2px solid blue' }} />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginBottom: 20 }}>
            <button onClick={handleToggleAudio} style={{ backgroundColor: '#1976d2', color: 'white' }}>
              {audioEnabled ? 'Mute Audio' : 'Unmute Audio'}
            </button>
            <button onClick={handleToggleVideo} style={{ backgroundColor: '#1976d2', color: 'white' }}>
              {videoEnabled ? 'Turn Camera Off' : 'Turn Camera On'}
            </button>
            <button onClick={handleShareScreen} style={{ backgroundColor: '#1976d2', color: 'white' }}>
              {screenSharing ? 'Stop Sharing' : 'Share Screen'}
            </button>
            <button onClick={handleEndCall} style={{ backgroundColor: '#d32f2f', color: 'white' }}>
              End Call
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default RosaWApp;
